/* eslint-disable max-len */
import React, { type SVGProps } from 'react';
import Icon from './Icon';

const FlameIcon: React.FunctionComponent<SVGProps<SVGSVGElement>> = (props) => (
  <Icon width="18px" height="20px" viewBox="0 0 18 20" {...props}>
    <g transform="translate(-18.000000, -8.000000)">
      <g transform="translate(18.000000, 7.500000)">
        <path d="M8.99997914,20.499994 C13.832388,20.499994 17.7499583,16.4706915 17.7499583,11.5000002 C17.7499583,9.41916414 15.7194761,5.12737291 12.8890156,2.50004172 C12.0765251,3.25394141 11.3429606,4.04651917 10.6929377,4.84260644 C9.62810569,3.37582069 8.30780397,1.88793972 6.81248435,0.500041723 C2.97422141,4.06135831 0.25,8.70158314 0.25,11.5000002 C0.25,16.4706915 4.16757031,20.499994 8.99997914,20.499994 Z M9.11171135,16.750003 C6.29334344,16.750003 3.99999106,14.8851545 3.99999106,11.8574365 C3.99999106,10.3492233 4.94958139,9.02033849 6.84334518,6.75002682 C7.11403545,7.06176314 10.7038859,11.6461028 10.7038859,11.6461028 L12.9941102,9.0336136 C13.1558149,9.30117583 13.3031,9.56290159 13.4343253,9.81367919 C14.502705,11.852363 14.0519233,14.4609612 12.1284812,15.8066306 C11.2823834,16.3988228 10.239028,16.750003 9.11171135,16.750003 Z" />
      </g>
    </g>
  </Icon>
);

export default FlameIcon;
